/** @format */

import angular from 'angular';

import { AppRoutes } from './app-routes.constant.js';

export const RoutesModule = angular.module('galabid-presenter.shared.routes', []).constant('AppRoutes', AppRoutes).name;
